module.exports = __webpack_public_path__ + "img/boldvueUpload-min.6828b723.jpg";